import { Switch, Redirect } from 'react-router-dom';
import { Route } from 'components/route';
import { lazy } from 'react';

const LoginPage = lazy(() => import('./pages/login'));
const HowItWorksPage = lazy(() => import('./pages/how-it-works'));
const Faq = lazy(() => import('./pages/faq'));
const Contact = lazy(() => import('./pages/contact'));
const TermsAndConditions = lazy(() => import('./pages/terms-and-conditions'));
const AboutPage = lazy(() => import('./pages/about'));
const ActiveAuctionsPage = lazy(() => import('./pages/active-auctions'));
const PreviewAuctionsPage = lazy(() => import('./pages/preview-auctions'));
const HomePage = lazy(() => import('./pages/home'));
const SingleAuctionPage = lazy(() => import('./pages/single-auction'));
const MyAuctionsPage = lazy(() => import('./pages/my-auctions'));
const ApprovedBiddersPage = lazy(() => import('./pages/approved-bidders'));
const JewelListingPage = lazy(() => import('./pages/jewel-listing'));
const UserPage = lazy(() => import('./pages/user-page'));

const getCatalogRoutes = url => {
  return CONFIG.AUCTION_TYPE === 'collection' ? url.replace('-auctions', '-collections') : url;
};

export const ROUTE_PATHS = {
  LOGIN: '/login',
  HOW_IT_WORKS: '/how-it-works',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  FAQ: '/faq',
  ABOUT: '/about',
  CONTACT: '/contact',
  HOME: '/home',
  ACTIVE_AUCTIONS: getCatalogRoutes('/active-auctions'),
  ACTIVE_AUCTIONS_AUCTION: getCatalogRoutes('/active-auctions/auction/:auctionId'),
  ACTIVE_AUCTIONS_LISTING: getCatalogRoutes(
    '/active-auctions/auction/:auctionId/listing/:listingId'
  ),
  PREVIEW_AUCTIONS: getCatalogRoutes('/preview-auctions'),
  PREVIEW_AUCTIONS_AUCTION: getCatalogRoutes('/preview-auctions/auction/:auctionId'),
  PREVIEW_AUCTIONS_LISTING: getCatalogRoutes(
    '/preview-auctions/auction/:auctionId/listing/:listingId'
  ),
  MY_LOTS: '/my-lots',
  MY_LOTS_AUCTION: '/my-lots/auction/:auctionId',
  MY_LOTS_LISTING: '/my-lots/auction/:auctionId/listing/:listingId',
  MY_BIDS: '/my-bids',
  MY_BIDS_AUCTION: '/my-bids/auction/:auctionId',
  MY_BIDS_LISTING: '/my-bids/auction/:auctionId/listing/:listingId',
  CLOSE_AUCTIONS: getCatalogRoutes('/close-auctions'),
  CLOSE_AUCTION: getCatalogRoutes('/close-auctions/auction/:auctionId'),
  CLOSE_LISTING: getCatalogRoutes('/close-auctions/auction/:auctionId/listing/:listingId'),
  MY_AUCTIONS: '/my-auctions',
  MY_AUCTION: '/my-auctions/:auctionId',
  ACCOUNTS: '/accounts'
};

const Routes = () => (
  <Switch>
    <Route path={ROUTE_PATHS.LOGIN}>
      <LoginPage />
    </Route>
    <Route path={ROUTE_PATHS.HOW_IT_WORKS} isWhiteBackground>
      <HowItWorksPage />
    </Route>
    <Route path={ROUTE_PATHS.CONTACT} isWhiteBackground>
      <Contact />
    </Route>
    <Route path={ROUTE_PATHS.TERMS_AND_CONDITIONS} isWhiteBackground>
      <TermsAndConditions />
    </Route>
    <Route path={ROUTE_PATHS.HOME}>
      <HomePage />
    </Route>
    <Route path={ROUTE_PATHS.FAQ} isWhiteBackground>
      <Faq />
    </Route>
    <Route path={ROUTE_PATHS.ABOUT} isWhiteBackground>
      <AboutPage />
    </Route>
    <Route
      path={[
        ROUTE_PATHS.ACTIVE_AUCTIONS_LISTING,
        ROUTE_PATHS.PREVIEW_AUCTIONS_LISTING,
        ROUTE_PATHS.CLOSE_LISTING,
        ROUTE_PATHS.MY_BIDS_LISTING,
        ROUTE_PATHS.MY_LOTS_LISTING
      ]}
    >
      <JewelListingPage />
    </Route>
    <Route path={ROUTE_PATHS.CLOSE_AUCTIONS} isPrivate>
      <UserPage isClosesAuction />
    </Route>
    <Route path={ROUTE_PATHS.PREVIEW_AUCTIONS}>
      <PreviewAuctionsPage />
    </Route>
    <Route path={ROUTE_PATHS.ACTIVE_AUCTIONS}>
      <ActiveAuctionsPage />
    </Route>
    <Route path={ROUTE_PATHS.MY_LOTS} isPrivate>
      <UserPage isMyLots />
    </Route>
    <Route path={ROUTE_PATHS.MY_BIDS} isPrivate>
      <UserPage isMyBids />
    </Route>
    <Route path={ROUTE_PATHS.MY_AUCTION} isPrivate>
      <SingleAuctionPage />
    </Route>
    <Route path={ROUTE_PATHS.MY_AUCTIONS} isPrivate>
      <MyAuctionsPage />
    </Route>
    <Route path={ROUTE_PATHS.ACCOUNTS} isPrivate>
      <ApprovedBiddersPage />
    </Route>
    <Route path="/">
      <Redirect to={ROUTE_PATHS.ACTIVE_AUCTIONS} />
    </Route>
  </Switch>
);

export default Routes;
